import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'actions';
import NumberHelper from 'helpers/number-helper';
import InputText from 'components/atoms/inputs/input-text';

class FilterInput extends Component {
    constructor(props) {
        super(props);
        this.isValueBeingChanged = false;
        this.state = {
            fieldValue: '',
        };
    }

    onChange(value) {
        this.isValueBeingChanged = true;
        this.setState({fieldValue: value});
    }

    onBlur(value) {
        const boundaryValue = this.prepareValue(value);

        this.onChange(boundaryValue);
        this.isValueBeingChanged = false;

        const {mode, fieldName} = this.props;
        this.props.dispatch(
            Action.set('InnerPointsBoundary', {
                [mode]: {
                    [fieldName]: boundaryValue,
                },
            }),
        );
    }

    prepareValue(value) {
        const {boundary, mode, fieldName} = this.props;

        const defaultMin = boundary.getInnerMin(mode);
        const defaultMax = boundary.getInnerMax(mode);

        let min = defaultMin;
        let max = defaultMax;
        if ('min' === fieldName) {
            min = boundary.getOuterMin(mode);
        } else {
            max = boundary.getOuterMax(mode);
        }

        const floatPrecision = 3;
        const defaultValue = boundary.getOuterBoundary(fieldName, mode);
        return NumberHelper.prepareFloat(value, floatPrecision, defaultValue)
            .limitByRange(min, max, defaultMin, defaultMax)
            .get();
    }

    getValue() {
        let currentValue = this.state.fieldValue;

        if (!this.isValueBeingChanged || !currentValue) {
            const {boundary, mode, fieldName} = this.props;
            currentValue = boundary.getInnerBoundary(fieldName, mode) || '';
        }

        return currentValue;
    }

    render() {
        const {testId} = this.props;
        const currentValue = this.getValue();

        return (
            <InputText
                value={currentValue}
                onBlur={this.onBlur.bind(this)}
                keyboard="number"
                testId={testId} />
        );
    }
}

function mapStatesToProps(state) {
    const {pointsBoundary} = state;

    return {
        boundary: pointsBoundary,
    };
}

export default connect(mapStatesToProps)(FilterInput);
